// Reduced motion: hold the homepage hero video on its first frame.
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('video[data-hero-video]').forEach((video) => {
    video.removeAttribute('autoplay');
    video.pause();
  });
}

// Touch-screen colour reveal for homepage and collection imagery.
// Marks images that sit in the middle band of the viewport with `.is-centered`
// so CSS can lift the grayscale filter; pointer/hover devices are left to CSS hover.
const touchQuery = window.matchMedia('(hover: none), (pointer: coarse)');
const IMAGE_SELECTOR = 'main:is([data-template="index"], [data-template="collection"]) :is(img, video):not(header *)';

if (touchQuery.matches && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        entry.target.classList.toggle('is-centered', entry.isIntersecting);
      }
    },
    { rootMargin: '-15% 0px -15% 0px', threshold: 0 }
  );

  const watch = (root) => {
    root.querySelectorAll?.(IMAGE_SELECTOR).forEach((image) => observer.observe(image));
  };

  document.documentElement.classList.add('mono-touch');
  watch(document);

  // Filtering and pagination swap grid markup in place; pick up the new images.
  const main = document.querySelector('main');
  if (main) {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches(IMAGE_SELECTOR)) observer.observe(node);
          watch(node);
        });
      }
    }).observe(main, { childList: true, subtree: true });
  }
}
